import { Section } from "../../../_enums/jobAndTalent";

export interface ScreenSetting {
  candidateName: string,
  jobDetails: string

}


 export const AllowedSectionsForIndexDb = [
  Section.PanelShortlistingFormA,
  Section.PanelShortlistingFormB,
  Section.PanelInterviewingForm,
  Section.ScreeningForm,
  Section.InitialSift,
  Section.Shortlisting,
];

export let IndexDBLocation = {
  CandidateListLeftAction: 1,
  CandidateDetailView: 2
};


export let IndexDBFormTypes = {
  PanelShortlistingFormA: 37,
  PanelShortlistingFormB: 38,
  PanelInterviewingForm: 39,
  InitialSift: 31,
  Shortlisting: 32,
  PanelShortlisting: 32,
  ScreeningForm: 30,
};
